/**
 * @file api 接口统一出口
 * @version
 * @author pankzou
 * @date 2021-10-08
 * @lastModified
 * @lastModifiedDate
 */

import example from './modules/example'
import user from './modules/user'
import test from './modules/test'
import query from './modules/query'



export default {
    example,
    user,
    test,
    query
}